import React, { useState } from "react";
import examQuestions from "../data/examQuestions";

const QuestionList = () => {
  const [activeQuestion, setActiveQuestion] = useState(null);

  const toggleQuestion = (id) => {
    setActiveQuestion(activeQuestion === id ? null : id);
  };

  return (
    <div>
      <h2>Lista wszystkich pytań</h2>
      <ul className="question-list">
        {examQuestions
          .sort((a, b) => a.id - b.id)
          .map((question, index) => (
            <li key={index} className="question-item">
              <h3 className="question-title">
                Pytanie {question.id}: {question.question}
              </h3>
              <ul className="answers-list">
                {Object.entries(question.answers).map(([key, answer]) => (
                  <li
                    key={key}
                    className={`answer-item ${
                      key === question.correct ? "correct" : ""
                    }`}
                  >
                    <strong>{key.toUpperCase()}.</strong> {answer}
                    {activeQuestion === question.id && (
                      <p className="explanation">
                        {question.explain[key]
                          ? question.explain[key]
                          : key === question.correct
                          ? question.rightAnswer
                          : ""}
                      </p>
                    )}
                  </li>
                ))}
              </ul>
              <div className="expand-button-container">
                <button
                  className="expand-button"
                  onClick={() => toggleQuestion(question.id)}
                >
                  {activeQuestion === question.id ? "Zwiń" : "Rozwiń"}
                </button>
              </div>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default QuestionList;
